/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm,  ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLConfirmationPolicyDetailsBox } from 'ml-capability-policychange-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import appConfig from 'app-config';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import { MLModalService } from 'ml-portals-services-react';
import { MLQuoteNameUtil } from 'ml-portals-util-js';
import { MLPortalStorageService } from 'ml-services-common-react'
import { Identify  } from "gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent";

import metadata from './MLRewriteConfirmationPage.metadata.json5';
import messages from './MLRewriteConfirmationPage.messages';
import styles from './MLRewriteConfirmationPage.module.scss'

import { TooltipIcon  } from '@jutro/components';

import { IntlContext } from '@jutro/legacy/locale';

const ML_STORAGE_KEY_SHOW_WV_REINSTATE_MSG = 'SHOW_WV_REINSTATE_MSG';
function MLRewriteConfirmationPage(props) {
    const {
        updateWizardData, wizardData, history
    } = props;
    const { submissionVM } = wizardData;
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const AlertService = MLNotificationBlockUtil();
    const policy = submissionVM.policy.value;
    const isGPA = appConfig.portalCode === 'GPA';

    const rewriteConfirmationMessage = (showWVRewriteMsg) => {
        AlertService.clearAlerts();
        AlertService.addSuccessAlert(translator(messages.congratulations), 'policyRewriteScreen');

        if (showWVRewriteMsg) {
            AlertService.addWarningAlert(translator(messages.congratulationsWV), 'policyRewriteScreenWV');
        }

    };
    
    
    useEffect(() => {
        Identify('Rewrite Step Reached', {step: 'Confirmation Screen'}, submissionVM, authHeader)
    }, [])
    
    useEffect(() => {
        const storagePromise = MLPortalStorageService.retrieve(null, policy.account.accountNumber, ML_STORAGE_KEY_SHOW_WV_REINSTATE_MSG, authHeader);
        storagePromise.then((response) => {
            if (response) {
                const resObj = JSON.parse(response);
                rewriteConfirmationMessage(resObj.shouldShow);
            }else{
                rewriteConfirmationMessage();
            }
        }).catch(() => {
            rewriteConfirmationMessage();
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

     useEffect(() => {
         if (isGPA) {
             PolChangeTrackEvent('Rewrite Confirmations Reached', false, submissionVM, authHeader, { step: 'PolChange Rewrite Confirmation Screen' });
         }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const printConfirmation = () => {
        window.print();
    };

    const goToAccount = () => {
        history.push(`/accounts/${submissionVM.value.policy.account.accountNumber}/summary`);
    };

    const anyOpenrClosedContingencies = () => {
        return submissionVM.value.openOrClosedContingencies.length > 0 ? true : false;
    };

    const formatDate = (gwDateVal) => {
        if(gwDateVal){
            const date = LocalDateUtil.toMidnightDate(gwDateVal);
            return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' })
        }
    };

    const isPersonalAuto = () => {
        return submissionVM.value.isPersonalAuto();
    };

    const viewPolicyDocuments = () => {
        history.push(`/policies/${submissionVM.value.policy.policyNumber}/documents`);
    };

    const viewIDCards = () => {
        history.push(`/accounts/${submissionVM.value.policy.account.accountNumber}/documents`);
    };

    const actionCell = (obj, index) => {
        if(index === 0){
            return <a onClick={viewPolicyDocuments}>{translator(messages.view)}</a>
        }
        return <a onClick={viewIDCards}>{translator(messages.view)}</a>
    }

    const documentCell = (obj, index) => {
        if(index === 0){
            return <>{translator(messages.yourPolicyDocuments)}</>
        }
        return <>{translator(messages.yourIDCards)}</>
    }

    const overrideProps = {
        documentTableHeader: {
            content: translator(messages.typePolicy, {
                policyType: MLQuoteNameUtil.getProductName(_.get(submissionVM, 'value.policy.product.publicID'))
            })
        },
        documentTable: {
            data: isPersonalAuto() ? [{},{}] : [{}] 
        },
        policyDetails: {
            changeTypeLabel: translator(messages.rewrite),
            policyNumber: _.get(submissionVM, 'value.policy.policyNumber'),
            paymentMethod: _.get(submissionVM, 'policy.billingDetails_ML.ratingPaymentMethod_ML.value.code'),
            endingIn: _.get(submissionVM, 'value.policy.billingDetails_ML.last4Digits_ML'),
            paymentSchedule:  _.get(submissionVM, 'value.policy.billingDetails_ML.paymentPlan_ML.name'),
            insured: _.get(submissionVM, 'value.policy.account.accountHolder', {}),
            secondaryInsured: _.get(submissionVM, 'value.policy.secondaryInsured_ML.displayName'),
            effectiveDate: formatDate(_.get(submissionVM, 'effectiveDate.value')),
            expirationDate: formatDate(_.get(submissionVM, 'expirationDate.value')),
        },
        anyOpenrClosedContingencies : {
            visible: anyOpenrClosedContingencies()
        },
        documentIterable: {
            content:anyOpenrClosedContingencies() ?(<div>
                {submissionVM.value.openOrClosedContingencies?.map((value) => {
                    return <div>
                        <li>{value.title} 
                        <TooltipIcon
                            text={value.description_ML}
                            />
                        </li>
                    </div>
                })}
            </div>): undefined 
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            printConfirmation,
            goToAccount,
            documentCell,
            actionCell
        },
        resolveComponentMap: {
            MLConfirmationPolicyDetailsBox
        }
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                
            />
        </WizardPage>
    );
}

export default withRouter(withViewModelService(MLRewriteConfirmationPage));